/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Gift_PrintInputs */

const vi_order_gift_print = /** @type {(inputs: Order_Gift_PrintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phiếu đóng gói / tem hộp`)
};

/**

* @param {Order_Gift_PrintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_gift_print = /** @type {((inputs?: Order_Gift_PrintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Gift_PrintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_gift_print(inputs)
});